import { userTypes, staffTypes } from "./../../types/userTypes";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CoreService } from "../../services/coreService";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

declare let toastr: any;

@Component({
    selector: "edit-parking-staff-modal",
    templateUrl: "./edit-parking-staff-modal.component.html",
    styleUrls: ["./edit-parking-staff-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule]
})
export class EditParkingStaffModalComponent implements OnChanges {
  staffs: any;
  form: UntypedFormGroup;
  isSubmitted = false;
  user_types;
  showSusbcriptions=false;
  susbscription_types;
  @Input() staff = null;
  @Input() parkingID = null;
  @Output() close = new EventEmitter();
  @Output() editStaff = new EventEmitter<any>();
  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<EditParkingStaffModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { staff, parkingID } = this.data;
    this.staff = staff;
    this.parkingID = parkingID;
    console.log("staff to edit", this.staff);
    this.form = this.builder.group({
      parking_place_id: [this.parkingID, Validators.required],
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/)
        ])
      ],
      mobileno: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("(^(\\+|0{2})\\d{12}$)|(^\\d{7,10}$)")
        ])
      ],
      user_type: ["", Validators.required],
      susbscription_type: [""]
    });
    this.setUp();
  }

  setUp() {
    this.form.reset();
    if (this.staff) {
      
      
      if(this.staff.user_type[0]=='Tenant'){
        this.form.setValue({
          parking_place_id: this.parkingID,
          first_name: this.staff.first_name,
          last_name: this.staff.last_name,
          email: this.staff.email,
          mobileno: this.staff.mobile_no,
          user_type: this.staff.user_type[0],
          susbscription_type: this.staff.subscription_type
        });
      this.showSusbcriptions=true;    
    }
    else{
      this.form.setValue({
        parking_place_id: this.parkingID,
        first_name: this.staff.first_name,
        last_name: this.staff.last_name,
        email: this.staff.email,
        mobileno: this.staff.mobile_no,
        user_type: this.staff.user_type[0],
        susbscription_type:""
      });
    }
    }
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.form.setValue({
      parking_place_id: this.parkingID,
      first_name: this.staff.first_name,
      last_name: this.staff.last_name,
      email: this.staff.email,
      mobileno: this.staff.mobile_no,
      user_type: this.staff.user_type[0],
      susbscription_type: this.staff.susbscription_type[0]
    });
    this.isSubmitted = false;
  }

  submitForm() {
    console.log(this.form.value);
    this.isSubmitted = true;
    if (this.form.valid) {
      this.editStaff.emit({ form: this.form.value, userID: this.staff.id });
      this.dialogRef.close({ form: this.form.value, userID: this.staff.id });
      this.resetModal();
    } else {
      toastr.error("", "Form is invalid.", {
        timeOut: 2000
      });
    }
  }
  async ngOnInit() {
    try {
      this.user_types = await this.coreService
        .GetParkingPlaceRegConfig()
        .then(response => response.user_types);
    } catch (error) {
      toastr.error("", "Failed to fetch user types.", {
        timeOut: 2000
      });
      this.closeModal();
    }
    try {
      this.susbscription_types = await this.coreService
         .GetParkingPlaceSuscription(this.parkingID)
         .then(response => response.data);
     } catch (error) {
       toastr.error("", "Failed to fetch Subscription types.", {
         timeOut: 2000
       });
       this.closeModal();
     }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.staff.currentValue != null) {
      this.resetModal();
    }
  }

  userTypeChange()
  {
    if(this.form.value.user_type=='Tenant'){
      this.showSusbcriptions=true;
    }
    else{
      this.showSusbcriptions=false;
    }  
  }
}
